import { gql, useQuery } from "@apollo/client";

const FETCH_AI_CHAT_HISTORY = gql`
query getAiChatHistory($user_id: Int4, $session_id: Uuid = "") {
  aiChatHistory(
    where: {userId: {_eq: $user_id}, sessionId: {_eq: $session_id}}
    order_by: {createdAt: Desc}
    limit: 30
  ) {
    message
    role
    id
    createdAt
    generatedLearningPath
  }
}
`;

const useFetchAiChatHistory = (userId, sessionId) => {
  const { data, loading, error } = useQuery(FETCH_AI_CHAT_HISTORY,
    {
      context: {
        headers: {
          "x-hasura-role": "learner"
        }
      },
      variables: {
        user_id: userId,
        session_id: sessionId
      },
      skip: !userId || !sessionId
    }
  );

  return { data: data?.aiChatHistory, loading, error };
}

export default useFetchAiChatHistory;